"use client";

import Image from "next/image";
import Link from "next/link";

type Props = {
  lang: "fr" | "en";
};

export default function Header({ lang }: Props) {
  const isFr = lang === "fr";
  const FlagFr = lang === "fr" ? "Drapeau français" : "French flag";
  const FlagEn = lang === "fr" ? "Drapeau anglais" : "English flag";

  const titleFlag = isFr
    ? "Vers le site version anglaise - Surpass - Notices produits"
    : "To the English version of the site - Surpass - Product manuals";
  return (
    <div className="m-header-front">
      <div className="container">
        <div className="m-header-front__wrapper">
          <div></div>

          <Image
            width={131}
            height={41}
            className="m-header-front__logo"
            src="/logo-white.svg"
            alt="Surpass - Notices"
          />

          <div className="m-header-front__info">
            <Link
              href={isFr ? "/en" : "/"}
              className="m-header-front__info__lang"
              title={titleFlag}
            >
              <Image
                src={isFr ? "/flag-en.svg" : "/flag-fr.svg"}
                alt={isFr ? FlagEn : FlagFr}
                width={18}
                height={12}
              />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
